module.exports = __webpack_public_path__ + "static/media/Workday_Step1b_Image4zzf.4dce595b.jpg";